export const PRINT_BODY_CLASS = 'printing-results'

export function clearPrintClass() {
  document.body.classList.remove(PRINT_BODY_CLASS)
}

/**
 * Prints only the results panel.
 * Adds a body class that the print stylesheet uses to hide everything except
 * the elements marked with `data-print="keep"`. Resolves once printing starts.
 */
export function printResults(): Promise<void> {
  return new Promise(resolve => {
    const cleanup = () => {
      clearPrintClass()
      window.removeEventListener('afterprint', cleanup)
      resolve()
    }
    window.addEventListener('afterprint', cleanup)
    document.body.classList.add(PRINT_BODY_CLASS)
    // Let the browser apply the print class before opening the dialog.
    window.setTimeout(() => {
      window.print()
      // Safari fires no afterprint reliably; clear on the next tick of any input.
      window.setTimeout(clearPrintClass, 1500)
    }, 60)
  })
}
